"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TouristsPickerMobile = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _localization = require("@lt/localization");
var _CounterPluralize = _interopRequireDefault(require("../../../CounterPluralize"));
var _Button = _interopRequireDefault(require("../../../Button"));
var _XMark = _interopRequireDefault(require("../../../../icons-react/rebrand/XMark"));
var _pluralizeUtils = require("../../../../utils/pluralizeUtils");
var _Reminder = require("../Reminder");
// Components:

// Interfaces:

// Utils:

var TouristsPickerMobile = exports.TouristsPickerMobile = function TouristsPickerMobile(props) {
  var adultsValue = props.adultsValue,
    _props$kidsValue = props.kidsValue,
    kidsValue = _props$kidsValue === void 0 ? [] : _props$kidsValue,
    _props$minValue = props.minValue,
    minValue = _props$minValue === void 0 ? 1 : _props$minValue,
    _props$maxValue = props.maxValue,
    maxValue = _props$maxValue === void 0 ? 4 : _props$maxValue,
    _props$maxChildren = props.maxChildren,
    maxChildren = _props$maxChildren === void 0 ? 3 : _props$maxChildren,
    _props$minChildAge = props.minChildAge,
    minChildAge = _props$minChildAge === void 0 ? 0 : _props$minChildAge,
    _props$maxChildAge = props.maxChildAge,
    maxChildAge = _props$maxChildAge === void 0 ? 17 : _props$maxChildAge,
    _props$onChangeAdults = props.onChangeAdults,
    onChangeAdults = _props$onChangeAdults === void 0 ? function () {
      return undefined;
    } : _props$onChangeAdults,
    _props$onChangeKids = props.onChangeKids,
    onChangeKids = _props$onChangeKids === void 0 ? function () {
      return undefined;
    } : _props$onChangeKids,
    _props$isMobileInput = props.isMobileInput,
    isMobileInput = _props$isMobileInput === void 0 ? false : _props$isMobileInput;
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  var kidsCount = kidsValue.length;
  var canAddChild = kidsCount < maxChildren;
  var handleChangeChildAge = function handleChangeChildAge(index, num) {
    var newKidsValue = (0, _toConsumableArray2["default"])(kidsValue);
    newKidsValue[index] = num;
    onChangeKids(newKidsValue);
  };
  var handleAddChildren = function handleAddChildren() {
    onChangeKids([].concat((0, _toConsumableArray2["default"])(kidsValue), [7]));
  };
  var handleRemoveChildren = function handleRemoveChildren(_ref) {
    var target = _ref.target;
    var index = target.dataset.index;
    var newKidsValue = kidsValue.filter(function (_, idx) {
      return idx !== parseInt(index, 10);
    });
    onChangeKids(newKidsValue);
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledRow, null, /*#__PURE__*/_react["default"].createElement(StyledText, null, t('touristsPicker.adult')), /*#__PURE__*/_react["default"].createElement(StyledCounterPluralize, {
    value: adultsValue,
    buttonSize: 44,
    onChange: onChangeAdults,
    minValue: minValue,
    maxValue: maxValue
  })), kidsValue.map(function (age, index) {
    return /*#__PURE__*/_react["default"].createElement(StyledRow, {
      key: "".concat(age, "-").concat(age + index)
    }, /*#__PURE__*/_react["default"].createElement(StyledIconRemove, {
      type: "button",
      "data-index": index,
      onClick: handleRemoveChildren
    }, /*#__PURE__*/_react["default"].createElement(_XMark["default"], {
      height: 20,
      "data-index": index
    })), /*#__PURE__*/_react["default"].createElement(StyledText, null, t('touristsPicker.child')), /*#__PURE__*/_react["default"].createElement(StyledCounterPluralize, {
      value: age,
      text: (0, _pluralizeUtils.pluralizeYears)(age),
      zeroValueText: age ? '' : t('touristsPicker.oneYear'),
      buttonSize: 44,
      onChange: function onChange(num) {
        return handleChangeChildAge(index, num);
      },
      minValue: minChildAge,
      maxValue: maxChildAge
    }));
  }), kidsCount < maxChildren ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !isMobileInput && /*#__PURE__*/_react["default"].createElement(_Reminder.Reminder, null), /*#__PURE__*/_react["default"].createElement(StyledAddChildButton, {
    disabled: !canAddChild,
    onClick: handleAddChildren
  }, t('touristsPicker.addChild')), isMobileInput && /*#__PURE__*/_react["default"].createElement(_Reminder.Reminder, null)) : null);
};
var StyledRow = _styledComponents["default"].div.withConfig({
  displayName: "TouristsPickerMobile__StyledRow",
  componentId: "sc-1xglkp3-0"
})(["display:flex;align-items:center;height:52px;padding:0 8px;"]);
var StyledText = _styledComponents["default"].span.withConfig({
  displayName: "TouristsPickerMobile__StyledText",
  componentId: "sc-1xglkp3-1"
})(["font-size:16px;font-weight:400;"]);
var StyledCounterPluralize = (0, _styledComponents["default"])(_CounterPluralize["default"]).withConfig({
  displayName: "TouristsPickerMobile__StyledCounterPluralize",
  componentId: "sc-1xglkp3-2"
})(["width:168px;margin-left:auto;"]);
var StyledIconRemove = _styledComponents["default"].button.withConfig({
  displayName: "TouristsPickerMobile__StyledIconRemove",
  componentId: "sc-1xglkp3-3"
})(["display:flex;justify-content:center;align-items:center;border:none;background:none;cursor:pointer;margin-right:8px;"]);
var StyledAddChildButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "TouristsPickerMobile__StyledAddChildButton",
  componentId: "sc-1xglkp3-4"
})(["align-self:center;width:100%;margin-top:10px;font-size:16px;line-height:20px;"]);